module.exports = __webpack_public_path__ + "static/media/icon-arrow-right-blue.524fc0ef.svg";